import React, { useRef, useState } from "react";
import TelegramEmbed from 'react-telegram-embed'
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad";
import AnimateHeightWrapper, { AnimateWrapperButton } from "../../Parts/Brid/common/components/AnimateHeightWrapper";

import shareIcon from "../../../../redesign/assets/icons/socialbutton-share.svg"

const TelegramPost = (props) => {

    const [visibility, setVisibility] = useState(false)

    const ref = (node) => {
        if (node !== null) {

            let interlvalId = setInterval(() => {
                let height = node.getBoundingClientRect().height
                console.log(height)
                if (height != undefined && height > 0) {
                    if (height > 450) {
                        setVisibility(true);
                    }

                    clearInterval(interlvalId);
                }
            }, 1000);
        }
    };


    return (
        <WithLazyLoad options={{
            height: 480,
            once: true,
            offset: 600
        }}>
            <AnimateHeightWrapper type={AnimateWrapperButton.ShowMore} height={450} visibility={visibility}>
                <CenteredEmbed ref={ref} >
                    <TelegramEmbed src={props.url} />
                </CenteredEmbed>
            </AnimateHeightWrapper>

        </WithLazyLoad>
    );
}

export default TelegramPost;

const CenteredEmbed = styled("div", {
    minHeight: "130px",
    position: "relative",
    "&::before": {
        minHeight: "350px",
        height: "100%",
        content: "",
        background: `transparent url("${shareIcon}") no-repeat center center`,
        backgroundSize: "60px",
        opacity: 0.4,
        top: "0",
        left: "0",
        right: "0",
        position: "absolute",
        zIndex: 0
    },
    iframe: {
        position: "relative"
    }
});